import { jsx, jsxs } from "react/jsx-runtime";
const SvgBookingPlaceholder = (props) => /* @__PURE__ */ jsxs("svg", { width: 96, height: 96, viewBox: "0 0 96 96", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: 48, cy: 48, r: 48, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 19, y: 24, width: 57, height: 12, fill: "#999999" }),
  /* @__PURE__ */ jsx("rect", { x: 19, y: 36, width: 57, height: 36, fill: "#CCCCCC" }),
  /* @__PURE__ */ jsx("rect", { x: 27, y: 19, width: 4, height: 8, fill: "#757575" }),
  /* @__PURE__ */ jsx("rect", { x: 64, y: 19, width: 4, height: 8, fill: "#757575" }),
  /* @__PURE__ */ jsx("rect", { x: 24, y: 41, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 24, y: 51, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 34, y: 41, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 34, y: 51, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 45, y: 41, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 45, y: 51, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 45, y: 61, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 55, y: 61, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 65, y: 61, width: 6, height: 6, fill: "#F2F2F2" }),
  /* @__PURE__ */ jsx("rect", { x: 55, y: 51, width: 6, height: 6, fill: "#FF620F" }),
  /* @__PURE__ */ jsx("rect", { x: 65, y: 51, width: 6, height: 6, fill: "#F2F2F2" })
] });
export default SvgBookingPlaceholder;
